import {AirtablePromotionItem} from '../../models/airtable';
import {canViewMembersOnlyPromotion, DRAWN_WINNERS_STATUS} from '../../stores/promotionAccess';

import {PromotionsGate} from './types';

const CAROUSEL = 'Carousel';
const FEED = 'Feed';

export const isDrawnWinnersPromotion = (promotion: AirtablePromotionItem) =>
  promotion.status === DRAWN_WINNERS_STATUS;
export const isEcommerceOnlyPromotion = (promotion: AirtablePromotionItem) =>
  promotion.eCommerceOnly;
export const isInStoreOnlyPromotion = (promotion: AirtablePromotionItem) => promotion.inStoreEntry;
export const isMembersOnlyPromotion = (promotion: AirtablePromotionItem) => promotion.membersOnly;
// Delegates to the single members-only rule in `stores/promotionAccess.ts` rather than
// restating it. `PromotionTile` gates one tile with the same function (DIS-1566), and this
// derives the gated collections from it (DIS-1567); two copies would let the badge on the
// Winners! tab disagree with what the list contains.
export const createFilterMembersOnlyPromotion =
  (gate: PromotionsGate) => (promotion: AirtablePromotionItem) =>
    canViewMembersOnlyPromotion(promotion, gate);

// NOT a display predicate. Feeds `activePromotions`, whose only consumer is
// `cartStore.ts:1228` — it decides which MFL competitions a completed order may still
// ENTER. Loosening this offers entry into an already-drawn competition. It looks
// interchangeable with `isActiveInStorePromotion` below; it is not (DIS-1564).
export const isActivePromotion = (promotion: AirtablePromotionItem) =>
  !isDrawnWinnersPromotion(promotion);
// Excluding drawn winners here is correct, not a workaround: a drawn promotion displays a
// result, and the draw happens after the promotion ends, so the record is already past its
// End Date. Do not add a client-side date window over drawn winners — that was PR #387 and
// it hides them exactly when they should appear (DIS-1563/DIS-1564).
export const isActiveInStorePromotion = (promotion: AirtablePromotionItem) =>
  !isDrawnWinnersPromotion(promotion) && !isEcommerceOnlyPromotion(promotion);
export const isDeepLinkOnlyPromotion = (promotion: AirtablePromotionItem) => promotion.hideOffer;
// Mirrors `isActiveInStorePromotion`'s draw rule so Current Promotions treats eCommerce-Only
// and in-store promotions identically. `PromotionsListScreen` appends this list for pickup or
// delivery stores, so without the drawn check the same screen would behave differently
// depending on the selected store's fulfilment type (DIS-1564).
export const isListedEcommerceOnlyPromotion = (promotion: AirtablePromotionItem) =>
  isEcommerceOnlyPromotion(promotion) &&
  !isDeepLinkOnlyPromotion(promotion) &&
  !isDrawnWinnersPromotion(promotion);

export const isCarouselPromotion = (promotion: AirtablePromotionItem) => {
  if (isDrawnWinnersPromotion(promotion) && !promotion.heroImage) {
    return false;
  }
  return [CAROUSEL, FEED].includes(promotion.type);
};
export const isFeedPromotion = (item: AirtablePromotionItem) =>
  item.type === FEED && !isDeepLinkOnlyPromotion(item);
